import type { FaireProductEntity } from "../../entity_types/product";

export const p_guayzwazxw: FaireProductEntity = {
  token: "p_guayzwazxw",
  type: "product",
  name: "Pink Tulip Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/932f348164a9c1f9ad7f2e88b070e0b6c954e1b56cc143ac0bfbead349491efb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84e2d259150e03d0f3291412274acd53de704d476e44080d48469dab2ef20a7b.jpeg",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:55.371Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
